module.exports = __webpack_public_path__ + "static/media/mitch-twin.fd9d26f2.png";